// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"208":"7e1e2f0d","282":"cae8f64c"}[chunkId] + ".chunk.css";
};